import { Component, Mixins, Prop } from 'vue-property-decorator';
import query from '../../queries/suggestionsListSummary';
import { UtilMixin } from '../../UtilMixin';
import CommentsList from './commentsList.vue';
import ProjectCard from './projectCard.vue';
import SectionTitle from './sectionTitle.vue';
import SpendingState from './spendingState.vue';

@Component({
  components: {
    SpendingState,
    CommentsList,
    ProjectCard,
    SectionTitle,
  },
})
export default class SuggestionsListSideBar extends Mixins(UtilMixin) {
  @Prop({ default: false }) public hideLibrary!: boolean;
  @Prop() public suggestionsListId!: string;
  @Prop({ default: false }) public showSuggestedBudget!: boolean;

  public readonly suggestionsListSummaryQuery = query;

  public get suggestionsListSummaryQueryVariables() {
    return {
      suggestionsListId: this.suggestionsListId,
    };
  }
}
